import React, { ReactElement, useState } from 'react';

const Test = (): ReactElement => {
  const [error, setError] = useState<string | null>(null);

  if (error) {
    throw new Error(error);
  }

  return (
    <>
      {/* <h2>Test Comp</h2> */}

      <p> Throws error that is recorded in sentry </p>
      <button
        onClick={() => {
          throw Error('Test Sentry Error from OmniBlu Extend: after build error fix');
        }}
      >
        Test Sentry Error
      </button>
      <br />
      <p>Sentry user feedback dialog will be displayed only if error is caught by error boundary</p>
      <p>Throws error that is recorded in sentry as well as by error boundary</p>
      <button
        onClick={() => {
          try {
            throw new Error('Test Sentry Error from OmniBlu Extend: after build error fix');
          } catch (e) {
            setError(e.message);
          }
        }}
      >
        Break for userFeedback
      </button>
    </>
  );
};

export default Test;
